export const highlightTypes = {
    inactiveSeller: 'inactive-seller',
    sellerOnVacation: 'seller-on-vacation',
    proVerified: 'pro-verified',
    collaborate: 'collaborate',
    saved: 'saved',
    matchingIndustries: 'matching-industries',
    loyalty: 'loyalty',
    language: 'language',
    responsive: 'responsive',
};
